import ReconnectingWebSocket from 'reconnecting-websocket';
import localDB from "../data/localDB";
let GLOBAL = require('../data/globals');

const ConnectSocket = {
    connect_printer() {
        let socket = new WebSocket(GLOBAL.WS_PRINTER);
        socket.onerror = () => {
            socket.close();
        };
        return  socket
    },
    store() {
        try {
            let socket = new ReconnectingWebSocket(`${GLOBAL.WS_QUIPUU}/store?${localDB.get('token')}`);
            socket.onerror = (e) => {
                socket.close();
            };
            return  socket
        }catch (e) {
            console.log('error_socket')
        }
    },
};

export default ConnectSocket;



// WEBPACK FOOTER //
// ./src/functions/socket.js